import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faEnvelope, faPaperPlane, faShieldAlt } from '@fortawesome/free-solid-svg-icons';

const ForgotPassword = ({ ipserv, onBack, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        const cleanEmail = email.trim().toLowerCase();
        if (!cleanEmail) {
            Notify({ type: 'fail', text: 'Ingresa el correo registrado.' });
            return;
        }

        setLoading(true);
        const API_BASE = ipserv || process.env.REACT_APP_API_URL || 'http://localhost:5000/';

        request.Post(API_BASE + 'auth/forgot-password', { email: cleanEmail }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Solicitud procesada correctamente.' });
                if (onSuccess) onSuccess();
            } else {
                Notify({ type: 'fail', text: r.msg || 'No pudimos procesar la solicitud.' });
            }
            setLoading(false);
        }, 'json', err => {
            Notify({ type: 'fail', text: err?.msg || 'Error de conexion.' });
            setLoading(false);
        });
    };

    return (
        <div className="w-100">
            <button
                type="button"
                className="auth-back-btn mb-4"
                onClick={onBack}
            >
                <FontAwesomeIcon icon={faArrowLeft} /> Volver al login
            </button>

            <div className="auth-mini-icon mb-3">
                <FontAwesomeIcon icon={faShieldAlt} />
            </div>
            <h1 className="auth-title">Recuperar acceso</h1>
            <p className="auth-subtitle">
                Indica el correo asociado a tu cuenta. Te enviaremos un enlace seguro para crear una nueva contraseña.
            </p>

            <form onSubmit={handleSubmit}>
                <div className="auth-input-group mb-4">
                    <input
                        type="email"
                        className="auth-input"
                        placeholder="correo@empresa.com"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        autoComplete="email"
                        required
                    />
                    <FontAwesomeIcon icon={faEnvelope} className="auth-input-icon" />
                </div>

                <button type="submit" className="auth-btn-primary mb-4" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : (
                        <><FontAwesomeIcon icon={faPaperPlane} /> Enviar enlace</>
                    )}
                </button>

                <div className="auth-note">
                    Por seguridad, si el correo no existe mostraremos el mismo resultado. El enlace vence en 60 minutos.
                </div>
            </form>
        </div>
    );
};

export default ForgotPassword;
